'use strict'

export default class questionusers {
    constructor(
        name = "",
        email = "",
        comment = "",
    ) {
        this.name = name
        this.email = email
        this.comment = comment
    }

}